/* eslint-disable @typescript-eslint/camelcase */

interface Logo {
  url?: string;
}

export default class Customer {
  id = 0;

  address_id?: number;

  first_name = '';

  last_name = '';

  name = '';

  logo?: Logo;
}
